import React, { useEffect, useState } from "react";
import "./BanksModal.scss";
import ReactModal from "react-modal";
import { Form, Col } from "react-bootstrap";
import { Formik } from "formik";
import Loader from "../loader/loader";
import { GetPricingEquipmentTemplate, assignPETemplate } from "../../api/index";
import Select from "react-select";

export default function AssignTemplateModal(props) {
    const [show_spinner, setShowSpinner] = useState(false);
    const [pe_templates, setPETemplates] = useState([]);
    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        selected_template: "",
    });

    useEffect(() => {
        GetPricingEquipmentTemplate()
            .then((response) => {
                console.log("response", response);
                if (response.success) {
                    let options = response.data.map((item) => {
                        return { label: item.template_name, value: item.id };
                    });
                    setPETemplates(options);
                    console.log("options", options);
                }
            })
            .catch((err) => {
                console.log("err", err);
            });
    }, []);

    const onSubmit = (e) => {
        console.log(e);

        if (e.selected_template != "") {
            let post_data = {
                app_id: props.appId,
                selected_template: e.selected_template.value,
            };

            assignPETemplate(post_data)
                .then((res) => {
                    console.log("assignPETemplate", res);
                    if (res.status) {
                        props.handleClose();
                    } else {
                        setError("* Something went wrong!");
                    }
                })
                .catch((err) => {
                    console.log("err", err);
                });
        } else {
            setError("* Please select a template");
        }
    };

    const assignTemplate = () => {};

    return (
        <ReactModal isOpen={props.show} className="banks-modal">
            <div className="modal-header">
                <h4 className="text-left">Please select your template</h4>
            </div>
            <div className="modal-body" style={{ marginTop: "50px" }}>
                <Formik
                    enableReinitialize
                    // validationSchema={schema}
                    onSubmit={(e) => onSubmit(e)}
                    initialValues={formData}
                    validateOnBlur={false}
                >
                    {({ touched, handleChange, values, handleSubmit }) => (
                        <Form
                            noValidate
                            autoComplete="off"
                            onSubmit={handleSubmit}
                            // onChange={(e) => this.handleOnChange(e)}
                        >
                            <Form.Row>
                                <Form.Group as={Col} xs={12} className="px-3">
                                    <div className="d-flex flex-row phone-prefix">
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="selected_template"
                                            options={pe_templates}
                                            onChange={(selected) => {
                                                setFormData({
                                                    selected_template: selected,
                                                });
                                                setError("");
                                            }}
                                        />
                                    </div>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {error}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <div
                                className="modal-footer"
                                style={{ marginTop: "250px" }}
                            >
                                <button
                                    className="btn cancel-button"
                                    type="button"
                                    onClick={() => props.handleClose()}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn confirm-button"
                                    type="submit"
                                >
                                    Assign
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            {show_spinner ? (
                <div className="spinner">
                    <Loader />
                </div>
            ) : (
                ""
            )}
        </ReactModal>
    );
}
